<template>
  <div class="content">
    <div class="row sidebar-img">
      <div class="col-lg-5 col-md-5 col-sm-5">
        <img :src="img1" class="mb-4" />
        <img :src="img2" />
      </div>
      <div class="col-lg-5 col-md-5 col-sm-5">
        <img :src="img3" class="mb-4" />
        <img :src="img4" />
      </div>
    </div>
  </div>
</template>

<script>
  import img1 from "../assets/images/chien.png";
  import img2 from "../assets/images/vache.png";
  import img3 from "../assets/images/chat.png";
  import img4 from "../assets/images/cheval.png";
  export default {
    name: "SideBar",
    data() {
      return {
        img1,
        img2,
        img3,
        img4,
      };
    },
  };
</script>
<style scoped>
  .sidebar-img img {
    width: 100%;
  }
</style>
